'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@src/utils/tailwind';
interface PriceProps {
  oldPrice?: number;
  oldPriceSuffix?: string;
  newPrice: number;
  newPriceSuffix?: string;
  size?: 'small' | 'large';
  currencySymbol: string;
  symbolPosition: 'before' | 'after';
}
export const Price = props => {
  const $ = _c(24);
  const {
    oldPrice,
    oldPriceSuffix,
    newPrice,
    newPriceSuffix,
    size,
    currencySymbol,
    symbolPosition: t0
  } = props;
  const symbolPosition = t0 === undefined ? "before" : t0;
  let t1;
  if ($[0] !== currencySymbol || $[1] !== oldPrice || $[2] !== size || $[3] !== symbolPosition) {
    t1 = oldPrice && <div className={cn("flex text-bodi-gray-disabled", {
      "flex-row-reverse": symbolPosition === "after"
    })}><span className={cn("gap-1 font-semibold lg:pt-1", {
        "text-body-sm": size === "small",
        "text-body-xl": size === "large"
      })}>{currencySymbol}</span><span className={cn("line-through decoration-2", {
        "text-heading-display-3": size === "small",
        "text-heading-display-2": size === "large"
      })}>{oldPrice}</span></div>;
    $[0] = currencySymbol;
    $[1] = oldPrice;
    $[2] = size;
    $[3] = symbolPosition;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = size === "small";
  const t3 = size === "large";
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = cn("self-end pr-2 pl-0.5 font-medium text-bodi-gray-disabled lg:pb-0.5", {
      "text-body-sm pb-0.5": t2,
      "text-body-xl": t3
    });
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== oldPriceSuffix || $[9] !== t4) {
    t5 = <span className={t4}>{oldPriceSuffix}</span>;
    $[8] = oldPriceSuffix;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== currencySymbol || $[12] !== newPrice || $[13] !== size || $[14] !== symbolPosition) {
    t6 = newPrice && <div className={cn("flex", {
      "flex-row-reverse": symbolPosition === "after"
    })}><span className={cn("gap-1 font-semibold lg:pt-1", {
        "text-body-sm": size === "small",
        "text-body-xl": size === "large"
      })}>{currencySymbol}</span><span className={cn("", {
        "text-heading-display-3": size === "small",
        "text-heading-display-2": size === "large"
      })}>{newPrice}</span></div>;
    $[11] = currencySymbol;
    $[12] = newPrice;
    $[13] = size;
    $[14] = symbolPosition;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== newPriceSuffix || $[17] !== size) {
    t7 = newPriceSuffix && <span className={cn("self-end pl-0.5 font-medium lg:pb-0.5", {
      "text-body-sm pb-0.5": size === "small",
      "text-body-xl": size === "large"
    })}>{newPriceSuffix}</span>;
    $[16] = newPriceSuffix;
    $[17] = size;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t1 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <div className="flex justify-center">{t1}{t5}{t6}{t7}</div>;
    $[19] = t1;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};